// Ficha de cadastro de cliente em branco, para imprimir e preencher a caneta.
// Campos em linhas simples. Pede letras MAIÚSCULAS de forma, que reduzem erros de leitura
// quando a ficha for lida por OCR.

// peso: largura relativa do campo dentro da linha da folha
const CAMPOS = {
  nome: { rotulo: 'Nome completo', peso: 1 },
  cpf: { rotulo: 'CPF', peso: 4 },
  cnpj: { rotulo: 'CNPJ (pessoa jurídica)', peso: 5 },
  rg: { rotulo: 'RG', peso: 4 },
  telefone: { rotulo: 'Telefone / WhatsApp (com DDD)', peso: 4 },
  email: { rotulo: 'E-mail', peso: 6 },
  cep: { rotulo: 'CEP', peso: 3 },
  logradouro: { rotulo: 'Logradouro (rua, avenida...)', peso: 9 },
  numero: { rotulo: 'Número', peso: 2 },
  complemento: { rotulo: 'Complemento', peso: 5 },
  bairro: { rotulo: 'Bairro', peso: 5 },
  cidade: { rotulo: 'Cidade', peso: 8 },
  uf: { rotulo: 'UF', peso: 1.5 },
};

// Dados que vêm do documento (CNH, RG) e por isso ficam de fora da ficha simplificada
const IDENTIFICACAO = ['nome', 'cpf', 'cnpj', 'rg'];

export const FICHAS = {
  completa: {
    titulo: 'Ficha de Cadastro de Cliente',
    secoes: [
      { titulo: 'Identificação', linhas: [['nome'], ['cpf', 'cnpj', 'rg']] },
      { titulo: 'Contato', linhas: [['telefone', 'email']] },
      { titulo: 'Endereço', linhas: [['cep', 'logradouro'], ['numero', 'complemento', 'bairro'], ['cidade', 'uf']] },
    ],
  },
  contatoEndereco: {
    titulo: 'Ficha de Endereço e Contato',
    subtitulo: 'Use junto com a foto ou PDF do documento (CNH, RG): o CPF abaixo liga esta ficha ao documento.',
    secoes: [
      { titulo: 'Identificação', linhas: [['cpf', 'cnpj']] },
      { titulo: 'Contato', linhas: [['telefone', 'email']] },
      { titulo: 'Endereço', linhas: [['cep', 'logradouro'], ['numero', 'complemento', 'bairro'], ['cidade', 'uf']] },
    ],
  },
};

const escapar = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

function htmlCampo(chave) {
  const campo = CAMPOS[chave];
  return `<div class="f" data-campo="${chave}" style="flex:${campo.peso} 1 0"><div class="linha-escrita"></div><div class="r">${escapar(campo.rotulo)}</div></div>`;
}

export function gerarFichaHtml(tipo = 'completa') {
  const ficha = FICHAS[tipo] || FICHAS.completa;
  const secoes = ficha.secoes.map((s) => `
    <h2>${escapar(s.titulo)}</h2>
    ${s.linhas.map((linha) => `<div class="linha">${linha.map(htmlCampo).join('')}</div>`).join('')}`).join('');

  return `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="utf-8"><title>${escapar(ficha.titulo)}</title>
<style>
  @page { size: A4; margin: 0; }
  * { box-sizing: border-box; }
  body { margin: 0; font-family: Arial, Helvetica, sans-serif; color: #111; background: #ddd; }
  .folha { position: relative; width: 210mm; height: 297mm; margin: 0 auto; padding: 18mm 16mm; background: #fff; }
  h1 { font-size: 18pt; margin: 0 0 2mm; text-align: center; letter-spacing: 0.3mm; }
  .sub { font-size: 9pt; text-align: center; margin: 0 0 3mm; color: #444; }
  .instrucoes { font-size: 9.5pt; text-align: center; margin: 4mm 0 2mm; padding: 2.5mm 4mm; background: #f1f1f1; border-radius: 1.5mm; }
  h2 { font-size: 10.5pt; margin: 7mm 0 0; padding-bottom: 1mm; border-bottom: 0.3mm solid #111; text-transform: uppercase; letter-spacing: 0.4mm; }
  .linha { display: flex; gap: 8mm; margin-top: 9mm; }
  .f { min-width: 0; }
  .linha-escrita { height: 9mm; border-bottom: 0.3mm solid #333; }
  .r { font-size: 8pt; color: #555; margin-top: 1mm; }
  .assinatura { position: absolute; left: 16mm; right: 16mm; bottom: 18mm; font-size: 9pt; color: #333; }
  .assinatura p { margin: 0 0 12mm; }
  .assinatura .linhas { display: flex; gap: 10mm; }
  .assinatura .linhas div { border-top: 0.3mm solid #333; padding-top: 1mm; text-align: center; }
  .barra { position: fixed; top: 0; left: 0; right: 0; padding: 8px; text-align: center; background: #333; }
  .barra button { font-size: 14px; padding: 6px 18px; cursor: pointer; }
  @media print { body { background: #fff; } .folha { margin: 0; } .barra { display: none; } }
  @media screen { .folha { margin-top: 48px; margin-bottom: 16px; } }
</style></head><body>
<div class="barra"><button onclick="window.print()">Imprimir</button></div>
<div class="folha">
  <h1>${escapar(ficha.titulo)}</h1>
  ${ficha.subtitulo ? `<p class="sub">${escapar(ficha.subtitulo)}</p>` : ''}
  <div class="instrucoes">Preencha com caneta preta ou azul escura, em <b>LETRAS MAIÚSCULAS</b>, com letra legível.<br>Isso evita erros na leitura dos dados. Deixe em branco o que não souber.</div>
  ${secoes}
  <div class="assinatura">
    <p>Declaro que os dados acima são verdadeiros e autorizo o uso deles para o meu cadastro.</p>
    <div class="linhas"><div style="flex:3">Assinatura do cliente</div><div style="flex:1">Data&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;/</div></div>
  </div>
</div>
</body></html>`;
}

// Abre a ficha em uma nova janela, pronta para imprimir
export function abrirFichaCliente(tipo = 'completa') {
  const url = URL.createObjectURL(new Blob([gerarFichaHtml(tipo)], { type: 'text/html;charset=utf-8' }));
  const janela = window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return janela;
}

export { CAMPOS, IDENTIFICACAO };
